import { type DonutChartFactory, DonutChart as MantineDonutChart } from "@mantine/charts";
import { componentWrapper } from "../../utilities";
import styles from "./donut-chart.module.scss";
import type { IProps } from "./donut-chart.types";

/**
 * Donut chart component for displaying proportional data breakdowns.
 * @param props - Mantine DonutChart props.
 * @returns The DonutChart component.
 */
const DonutChart = componentWrapper<DonutChartFactory, IProps>("DonutChart", (props, ref) => {
    return (
        <MantineDonutChart
            ref={ref}
            classNames={{
                root: styles["container"],
            }}
            {...props}
        />
    );
});

export { DonutChart };
